module.exports = __webpack_public_path__ + "img/navigationClose.ccdb40c0.png";